import React from 'react'
import Person4Icon from '@mui/icons-material/Person4';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import SupplyBillAgreeCount from '../../../../supply/supplyBills/item/fields/agree/SupplyBillAgreeCount';

const WriteOffActAgreesCount = ({ writeOffAct }) => {

  return (
    <div className='supplyAgrees__column'>
        {
            writeOffAct && writeOffAct.items ?
                <SupplyBillAgreeCount
                    items={writeOffAct.items}
                    type={'isAgreeDirector'}
                    title='Погодження директором'
                    ico={<Person4Icon />}
                />
            : ''
        }
        {
            writeOffAct && writeOffAct.items ?
                <SupplyBillAgreeCount
                    items={writeOffAct.items}
                    type={'isAgreeAccountant'}
                    title='Погодження бухгалтером'
                    ico={<PointOfSaleIcon />}
                />
            : ''
        }
    </div>
  )
}

export default WriteOffActAgreesCount